import request from "@/utils/request";

//全部用户类型
export function user_type() {
    return request({
        url: "/account/user_type",
        method: "get"
    });
}

//检测手机号是否存在正常的免费账户
export function check_free_accounts(params) {
    return request({
        url: "/account/check_free_accounts",
        method: "get",
        params
    });
}

//发送验证码
export function send_sms(data) {
    return request({
        url: "/account/send_sms",
        method: "post",
        data
    });
}

//提交表单注册账户
export function submit_sms(data) {
    return request({
        url: "/account/submit_sms",
        method: "post",
        data
    });
}

//查询支付状态
export function pay_status(data) {
    return request({
        url: "/bill/pay_status",
        method: "post",
        data
    });
}

//代理发送验证码
export function agentSendSms(data) {
    return request({
        url: "/agent/send_sms",
        method: "post",
        data
    });
}

//创建代理
export function createAgent(data) {
    return request({
        url: "/agent/agents",
        method: "post",
        data
    });
}

//查看最新规则
export function get_rules() {
    return request({
        url: "/account/get_rules",
        method: "get"
    });
}

//登录
export function loginApi(data) {
    return request({
        url: "/admin/login",
        method: "POST",
        data,
    });
}

//统计报表
export function statistics() {
    return request({
        url: "/stat/statistics",
        method: "get"
    });
}

//用户列表
export function userList(params) {
    return request({
        url: "/admin/user",
        method: "get",
        params
    });
}

//创建用户
export function addUser(data) {
    return request({
        url: "/admin/user",
        method: "POST",
        data,
    });
}

//编辑用户
export function editUser(id, data) {
    return request({
        url: `/admin/user/${id}`,
        method: "put",
        data
    });
}

//删除用户
export function deleteUser(id) {
    return request({
        url: `/admin/user/${id}`,
        method: "delete",
    });
}

//用户类型列表
export function usertype(params) {
    return request({
        url: "/admin/usertype",
        method: "get",
        params
    });
}

//删除用户类型
export function deleteUserType(id) {
    return request({
        url: `/admin/usertype/${id}`,
        method: "delete",
    });
}

//编辑用户类型
export function editUserType(id, data) {
    return request({
        url: `/admin/usertype/${id}`,
        method: "put",
        data
    });
}

//创建用户类型
export function addUserType(data) {
    return request({
        url: "/admin/usertype",
        method: "POST",
        data,
    });
}

//代理列表
export function agentList(params) {
    return request({
        url: "/admin/agent",
        method: "get",
        params
    });
}

//创建代理
export function addAgent(data) {
    return request({
        url: "/admin/agent",
        method: "POST",
        data,
    });
}

//编辑代理
export function editAgent(id, data) {
    return request({
        url: `/admin/agent/${id}`,
        method: "put",
        data
    });
}

//更新代理积分
export function editAgentPoints(id, data) {
    return request({
        url: `/admin/agent/subtract/${id}`,
        method: "put",
        data
    });
}

//删除代理
export function deleteAgent(id) {
    return request({
        url: `/admin/agent/${id}`,
        method: "delete",
    });
}

//账单列表
export function billList(params) {
    return request({
        url: "/admin/bill",
        method: "get",
        params
    });
}

//创建账单
export function addBill(data) {
    return request({
        url: "/admin/bill",
        method: "POST",
        data,
    });
}

//编辑账单
export function editBill(id, data) {
    return request({
        url: `/admin/bill/${id}`,
        method: "put",
        data
    });
}

//删除账单
export function deleteBill(id) {
    return request({
        url: `/admin/bill/${id}`,
        method: "delete",
    });
}

//第三方列表
export function thirdpartyList(params) {
    return request({
        url: "/admin/thirdparty",
        method: "get",
        params
    });
}

//创建第三方
export function addThirdparty(data) {
    return request({
        url: "/admin/thirdparty",
        method: "POST",
        data,
    });
}

//编辑第三方
export function editThirdparty(id, data) {
    return request({
        url: `/admin/thirdparty/${id}`,
        method: "put",
        data
    });
}

//删除第三方
export function deleteThirdparty(id) {
    return request({
        url: `/admin/thirdparty/${id}`,
        method: "delete",
    });
}

//规则列表
export function ruleList(params) {
    return request({
        url: "/admin/rules",
        method: "get",
        params
    });
}

//创建规则
export function addRule(data) {
    return request({
        url: "/admin/rules",
        method: "POST",
        data,
    });
}

//编辑规则
export function editRule(id, data) {
    return request({
        url: `/admin/rules/update/${id}`,
        method: "post",
        data
    });
}

//删除规则
export function deleteRule(id) {
    return request({
        url: `/admin/rules/${id}`,
        method: "delete",
    });
}

//积分日志列表
export function pointsList(params) {
    return request({
        url: "/admin/points_log",
        method: "get",
        params
    });
}

//创建积分日志
export function addPoints(data) {
    return request({
        url: "/admin/points_log",
        method: "POST",
        data,
    });
}

//编辑积分日志
export function editPoints(id, data) {
    return request({
        url: `/admin/points_log/${id}`,
        method: "put",
        data
    });
}

//删除积分日志
export function deletePoints(id) {
    return request({
        url: `/admin/points_log/${id}`,
        method: "delete",
    });
}

//黑名单列表
export function user_blacklist(params) {
    return request({
        url: "/admin/user_blacklist",
        method: "get",
        params
    });
}

//创建黑名单
export function add_user_blacklist(data) {
    return request({
        url: "/admin/user_blacklist",
        method: "POST",
        data,
    });
}

//修改黑名单
export function edit_user_blacklist(id, data) {
    return request({
        url: `/admin/user_blacklist/${id}`,
        method: "put",
        data
    });
}

//删除黑名单
export function delete_user_blacklist(id) {
    return request({
        url: `/admin/user_blacklist/${id}`,
        method: "delete",
    });
}

//个人信息
export function userInfoApi() {
    return request({
        url: "/admin/agent/info",
        method: "get"
    });
}

//刷新支付链接
export function refreshPayment(data) {
    return request({
        url: "/bill/tgpay/refresh-payment",
        method: "POST",
        data,
    });
}

//合同模板列表
export function contract_list() {
    return request({
        url: "/admin/contract/list",
        method: "get"
    });
}

//合同模板上传
export function contract_upload(data) {
    return request({
        url: "/admin/contract/upload",
        method: "POST",
        data
    });
}

//预览合同模板
export function contract_preview(id) {
    return request({
        url: `/admin/contract/${id}/preview`,
        method: "get"
    });
}

//删除合同模板
export function contract_delete(id) {
    return request({
        url: `/admin/contract/${id}`,
        method: "delete"
    });
}

//状态接口
export function enum_status() {
    return request({
        url: `/admin/enum_status`,
        method: "get"
    });
}

//查询峰值/权益
export function fund_and_profit(id) {
    return request({
        url: `/admin/user/fund_and_profit/${id}`,
        method: "get"
    });
}

//复位最大权益
export function reset_max_balance(id) {
    return request({
        url: "/admin/user/reset_max_balance",
        method: "POST",
        data: {
            user_id: id
        }
    });
}

//手动设置出入金
export function manual_deposit(data) {
    return request({
        url: "/admin/user/manual_deposit",
        method: "POST",
        data
    });
}

//查询盈利
export function get_user_profit(id) {
    return request({
        url: `/admin/user/by_user_id/${id}`,
        method: "get"
    });
}